module.exports = __webpack_public_path__ + "img/pwa-icon.82fceae6.svg";